export default __webpack_public_path__ + "static/media/16_FB39NA-min.973e05b1.jpg";